/** 规划第三阶段（计划 P3-3b）：案件页面的流程对话框与面板、第三阶段拒绝原因及新日志类型名称。 */
export default {
  workflow: {
    dialog: {
      confirm: '确认',
      cancel: '取消',
      optional: '选填',
      required: '此项必填。',
      choose: '请选择…',
      yes: '是',
      no: '否',
      notRecorded: '未记录',
      days: '天',
      effectiveHint: '生效日期：今天，或最多往前 30 天。',
      numberHint: '根据编号格式建议。如函件编号不同，请在确认前修改。',
      listMissing: '此列表尚不可用。',
      invalid: '以下数值被拒绝：',
      reason: '理由',
      agencies: '征询的机构',
      agenciesHint: '每个机构各发一份征询，适用本次分发的意见期限。',
      agenciesRequired: '请至少选择一个机构。',
      agencyOpen: '已征询',
      drawing: '图纸',
      drawingSame: '使用案件上已有的图纸',
      drawingSameHint: '最新图纸将作为下一版本重新检查。',
      drawingReplace: '上传修订图纸',
      drawingReplaceHint: '新图纸将成为下一版本。',
      drawingNoPrevious: '没有可重用的先前图纸，请上传一份。',
      uploading: '正在上传图纸… {{percent}}%',
      finalizing: '正在检查上传…',
      submitting: '正在保存…',
    },
    kinds: { internal: '议会部门', external: '外部机构' },
    conditions: {
      add: '添加条件',
      fromLibrary: '从条件库添加',
      chooseTemplate: '选择条件库中的条件…',
      pCode: '遵守阶段',
      text: '条件',
      remove: '移除',
      none: '尚无条件。',
      max: '最多 {{max}} 项条件。',
      code: '条件库代码 {{code}}',
      noOpen: '所有条件均已遵守。',
      digestOnly:
        '本案有 {{number}} 项条件来自其他系统，未附文本，无法在此显示。确认后，本案的条件将由下列清单取代，请先根据原始信函重新添加这些条件。',
    },
    decision: {
      title: '决定与条件',
      number: '决定编号 {{number}}，签发于 {{date}}',
      noNumber: '尚未签发决定编号。',
      conditions: '条件列表',
      noConditions: '未记录任何条件。',
      textAbsent: '此条件的内容由发送案件的系统保存。',
      complied: '已遵守',
      open: '尚未遵守',
      preGrant: '核准前须遵守',
    },
    flags: { title: '已记录的事实', counters: '计数' },
    referrals: {
      title: '征询',
      round: '第 {{round}} 轮',
      requested: '征询于 {{date}}',
      due: '意见截止 {{date}}',
      overdue: '期限已过',
      late: '逾期回复',
      answered: '回复于 {{date}}',
      status: { open: '等待意见', answered: '已回复', withdrawn: '已撤回' },
      none: '尚无征询。',
      request: '发出征询',
      requestTitle: '发出征询',
      requestHint: '每个机构适用最近一次分发的意见期限。',
      answer: '记录回复',
      answerTitle: '{{agency}} 的回复',
      outcome: '回复',
      answeredOn: '回复日期',
      deemedHint: '意见期限已过。请先确认 OSC 3.0 Plus 中没有回复，再记录视为无异议。',
      conditionsRequired: '提出要求时至少需要一项条件。',
      withdraw: '撤回',
      withdrawTitle: '撤回对 {{agency}} 的征询',
      withdrawBody: '该机构不再被要求提供意见。已发送的回复仍保留在案件中。',
      outcomes: { requirements: '有要求', no_requirements: '无要求', deemed: '视为无回复' },
      departmentNote: '仅显示发给贵部门的征询。',
      letterHint: '请将该机构的信函存入本案的“其他文件”：此处的回复仅记录结果和条件。',
    },
    links: {
      title: '关联案件',
      none: '没有关联案件。',
      relations: { km: '规划许可（KM）' },
      kinds: { case: '本系统中的案件', reference: '外部参考', exemption: '豁免' },
      parentAbsent: '关联案件不在本安装中。',
      reference: '参考编号 {{reference}}',
      validity: '签发于 {{issued}}，有效期至 {{until}}',
      link: '关联{{relation}}',
      linkTitle: '关联：{{relation}}',
      unlink: '解除关联',
      unlinkTitle: '解除关联{{relation}}',
      unlinkBody: '此关联将从本案件移除，另一案件不受影响。',
      target: '关联对象',
      searchLabel: '查找案件',
      searchPlaceholder: '参考编号或项目名称',
      search: '搜索',
      noResults: '没有匹配的案件。',
      chosen: '已选择：{{caseRef}}',
      referenceLabel: '参考编号',
      issuedOn: '签发日期',
      validUntil: '有效期至',
      chooseCase: '请先选择一个案件。',
    },
    documents: {
      title: '其他文件',
      none: '尚无其他文件。',
      revision: '第 {{revision}} 版',
      shared: '已向申请人显示',
      upload: '上传文件',
      uploadTitle: '上传文件',
      type: '文件类型',
      file: '文件',
      fileHint: '{{extensions}}，最大 {{max}} MB。',
      share: '向申请人显示此文件',
      shareHint: '上传后无法更改。',
      fileMissing: '请选择文件。',
      fileType: '请选择 {{extensions}} 文件。',
      fileEmpty: '文件为空。',
      fileTooLarge: '文件超过 {{max}} MB。',
      uploading: '正在上传… {{percent}}%',
      finalizing: '正在检查上传…',
      download: '下载',
      downloadLabel: '下载 {{name}}',
      added: '已添加文件',
      rejected: '文件被拒绝（{{reason}}）。',
    },
    department: {
      listTitle: '转介给贵部门的案件',
      listSubtitle: '由贵部门回复征询的规划案件。',
      empty: '没有转介给贵部门的案件。',
      detailNote: '您能看到此案件，是因为它已转介给贵部门。请在下方回复贵部门的征询。',
    },
    issues: {
      unknownKey: '发送了此操作不接受的数值',
      reasons: {
        missing: '必填',
        type: '数值无效',
        range: '超出允许范围',
        too_long: '过长',
        duplicate: '重复填写',
        unknown_code: '不在列表中',
        unknown_condition: '不是本案件的条件',
        future: '在未来',
        too_old: '早于 30 天前',
        before_previous_event: '早于案件最近记录的步骤',
        unknown_key: '此操作不接受',
      },
    },
    keys: {
      agencies: '机构',
      agency: '机构名称',
      referralId: '征询',
      outcome: '回复',
      answeredOn: '回复日期',
      conditions: '条件',
      targetCaseId: '关联案件',
      external: '外部参考',
      relation: '关联',
      linkId: '关联编号',
      windowDays: '意见期限',
      kind: '类型',
      reason: '理由',
    },
  },
  guards: {
    separation_of_duties_required: '撰写建议或最后提交的人不得作出决定',
    referrals_settled: '本轮仍有征询未获回复',
    check_latest_failed_overridable: '最近一次未通过的检查不能附例外接受',
    check_latest_passed_or_accepted: '最近一次检查未通过，也未被接受',
    input_date_not_after_clock_due: '日期不得晚于截止日期',
    link_present: '案件尚未关联其规划许可',
    link_parent_valid: '关联的规划许可尚未核准或已失效',
    constraints_determined: '须先由官员就限制检查结果作出判定',
    rules_determined: '须先由官员就规则结果作出判定',
  },
  errors: {
    input_invalid: '部分数值被拒绝。请更正下方标出的字段后重试。',
    condition_not_met: '此操作已不适用于案件当前状态。请重新加载页面查看可执行的操作。',
    decision_number_taken: '该决定编号已被其他案件使用。请输入其他编号。',
    no_referrals: '此案件的流程没有征询。',
    referral_not_found: '该征询不在此案件中，或不由您回复。',
    referral_exists: '该机构在此案件中已有未结的征询。',
    referral_closed: '该征询已回复或已撤回。',
    referral_not_due: '意见期限尚未届满，因此不能记录视为无异议。',
    relation_unknown: '此案件的流程不允许该关联。',
    link_exists: '此案件已有该用途的关联，请先解除。',
    link_not_found: '该关联已不在此案件中。',
    referral_requests_closed: '已停止发出新征询：委员会已就此案件作出决定。',
    referral_window_unknown: '请先分发案件：征询的意见期限取自分发。',
    link_target_not_found: '未找到该案件，或您无权查看。',
    link_kind_mismatch: '案件只能关联到关联类型所指定种类的上级案件，不能关联到同类案件。',
  },
  events: {
    referral_requested: '已发出征询',
    referral_answered: '征询已回复',
    referral_withdrawn: '征询已撤回',
    case_linked: '案件已关联',
    case_unlinked: '已解除案件关联',
    check_exceptions_accepted: '图纸检查已接受',
  },
} as const
